import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Avatar } from '@/features/auth/Avatar'
import { declineInvite } from './api'
import { invitesKey, useInvites } from './useFriends'

type Props = {
  enabled: boolean
  onOpen: (gameId: string) => void
}

/**
 * Приглашения в партию — на главной.
 *
 * Показываются списком, а не всплывашкой: всплывающее уведомление
 * приходится ловить, а приглашение живёт до ответа и должно спокойно ждать
 * на экране, с которого начинается игра.
 */
export function InviteList({ enabled, onOpen }: Props) {
  const client = useQueryClient()
  const invites = useInvites(enabled)

  const decline = useMutation({
    mutationFn: declineInvite,
    onSuccess: () => client.invalidateQueries({ queryKey: invitesKey }),
  })

  if (!enabled || (invites.data?.length ?? 0) === 0) return null

  return (
    <div className="card">
      <h2 className="card__title">Вас зовут играть</h2>
      <ul className="people">
        {invites.data?.map((invite) => (
          <li key={invite.id} className="person">
            <span className="person__who">
              <Avatar name={invite.from} />
              <span className="person__name">
                <span className="player__name">{invite.from}</span>
                <span className="muted">за столом {invite.players}</span>
              </span>
            </span>
            <button type="button" className="primary" onClick={() => onOpen(invite.gameId)}>
              сесть за стол
            </button>
            <button type="button" className="ghost" onClick={() => decline.mutate(invite.id)}>
              отказаться
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
